import { cn } from '@/lib/utils'

interface LogoProps {
  className?: string
  size?: 'sm' | 'md' | 'lg'
}

export function Logo({ className, size = 'md' }: LogoProps) {
  const sizes = {
    sm: 'text-sm',
    md: 'text-base',
    lg: 'text-xl',
  }

  const dotSizes = {
    sm: 'text-[10px]',
    md: 'text-xs',
    lg: 'text-sm',
  }

  return (
    <span className={cn('inline-flex items-baseline', sizes[size], className)}>
      <span className="font-light tracking-tight">zoni</span>
      <span className="font-bold tracking-tight">sigma</span>
      <span className={cn('font-normal text-primary/60 ml-px', dotSizes[size])}>.app</span>
    </span>
  )
}
